import { useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { Equipment } from '../../../../models/hull-models/Equipment'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { SkyPaper } from '../../../Core/Frames/SkyPaper'
import { getSvg } from '../../../Core/Hull/EquipmentView'


interface PolicyEquipmentViewProps {
    equipment: Equipment
}

export const EquipmentModifyView = ({equipment,defaultDeductibleRate}: PolicyEquipmentViewProps) => {
    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));

    return (
        <FlexView className="space-between">
            <FlexView vAlignContent={'center'}>
                <SkyPaper small>
                    {getSvg(equipment.type)}
                </SkyPaper>
                <div className="margin-left-basic">
                <FlexView column vAlignContent='center' hAlignContent='left'>
                    <div className="black bold text-small">{equipment.description}</div>
                    {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) &&
                    <>
                        <FlexView column={isMobile}>
                                {equipment.premium > 0 && <div className="gray text-tiny margin-top-3">
                                    Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipment.premium.toLocaleStringToFixed()} </div>}
                                    {equipment.premium > 0 && equipment.deductibleRate > 0 && !isMobile && <span style={{marginRight: '5px'}}>, </span>}
                                {equipment.deductibleRate > 0 && <div className="gray text-tiny margin-top-3">  Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{(equipment.value * equipment.deductibleRate/100).toLocaleStringToFixed()}</div>}        
                        </FlexView>
                        {defaultDeductibleRate != equipment.deductibleRate && <div className="gray text-tiny margin-top-3">*This item has a special deductible, please contact us to edit or modify</div>}
                    </>
                    }
                    </FlexView> 
                    </div>
            </FlexView>
        </FlexView>
    )
}